import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type {
  RemotePcAgent,
  RemotePcAgentListParams,
} from '~/features/remote-pc-agent/types/remote-pc-agent.type';

/**
 * 스토어 IP 목록 조회
 * @description STORE_MANAGER 이상 권한 필요 (STORE_MANAGER는 자신의 스토어만)
 * @endpoint GET /admin/remote-pc-agents
 * @param params - 조회 파라미터 (storeId 필수)
 * @returns Store IP 목록 및 페이지네이션 정보
 */
export function getRemotePcAgentListApi(params: RemotePcAgentListParams) {
  return axiosInstance.get<PaginatedApiResponse<RemotePcAgent>>('/admin/remote-pc-agents', {
    params,
  });
}
